import React from 'react';

export const responseBoolean = (respostas = '') => {
  return (
    <p>{(respostas === true && 'Sim') || (respostas === false && 'Não')}</p>
  );
};

export const filterResponses = (question, respostas = '') => {
  switch (question) {
    case 'tipoHospital':
      return (
        <p>
          {respostas === 'g' ? '- Hospital Geral' : '- Hospital Especializado'}
        </p>
      );

    case 'corpoClinicoHospital':
      return (
        <p>
          {(respostas === 'a' && 'Aberto') ||
            (respostas === 'f' && 'Fechado') ||
            (respostas === 'm' && 'Misto')}
        </p>
      );
    case 'estratificacoesDeRisco':
      return (
        <p>
          {(respostas === 'o' && '- Original') ||
            (respostas === 'a' && '- Adaptado')}
        </p>
      );

    default:
      break;
  }

  return <p>{respostas?.toString()}</p>;
};
